import { lazy } from "react"

const Register = lazy(() => import("../pages/Authentication/UserRegister/register"))
// const SignupElse = lazy(() => import("../pages/Authentication/SignupElse/signupElse"))
const SignupInvitedUser = lazy(() => import("../pages/Authentication/SignUpInvitedUser/signup"))
// const BatchPlayerSignUp = lazy(() => import("../pages/Authentication/BatchPlayerSignUp/BatchPlayerSignUp"))
const Login = lazy(() => import("../pages/Authentication/Login/Login"))
const ChangePassword = lazy(() => import("../pages/Authentication/ForgotPassword/changePassword"))
const ForgotPassword = lazy(() => import("../pages/Authentication/ForgotPassword/index"))
const VerifyOTP = lazy(() => import("../pages/Authentication/OTP/index"))
const verifyUserMail = lazy(() => import("../components/VerifyUserMail/index"))

const authRoutes = [
  { path: "/login/:msg?", component: Login },
  { path: "/VerifyOTP/:user_id", component: VerifyOTP },
  { path: "/forgot-password", component: ForgotPassword },
  { path: "/change-password/:token", component: ChangePassword },
  { path: "/signup", component: Register },
  // { path: "/SignupElse", component: SignupElse }, //pending
  { path: "/signup/:token", component: SignupInvitedUser },
  { path: "/signup/:token/:invited/:code/:clientid", component: SignupInvitedUser },
  { path: "/user/verification", component: verifyUserMail }, 
  // { path: "/player/signup/:token/:code/:clientid", component: BatchPlayerSignUp }, // pending
]

export default authRoutes;
